@if (mode === 'create' && initialTemplate) {
  <div class="of-template-note">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
    {{ 'preventionOffres.offerForm.template.badge' | translate: { name: initialTemplate.name } }}
  </div>
}

<div class="of-grid">
  <div class="of-col">
    <div class="card">
      <label class="of-label" for="offerName">{{ 'preventionOffres.offerForm.nameLabel' | translate }} *</label>
      <input
        id="offerName"
        class="input"
        type="text"
        maxlength="255"
        [value]="name()"
        [disabled]="readOnly"
        (input)="onNameChanged($any($event.target).value)"
        [placeholder]="'preventionOffres.offerForm.namePlaceholder' | translate">
      @if (nameTouched() && nameError()) {
        <div class="of-error">{{ ('preventionOffres.offerForm.errors.' + (nameError() === 'required' ? 'nameRequired' : 'nameTooLong')) | translate }}</div>
      }

      <label class="of-label" for="offerDescription" style="margin-top:14px">{{ 'preventionOffres.offerForm.descriptionLabel' | translate }}</label>
      <textarea
        id="offerDescription"
        class="textarea-ctrl"
        rows="3"
        [value]="description()"
        [disabled]="readOnly"
        (input)="onDescriptionChanged($any($event.target).value)"
        [placeholder]="'preventionOffres.offerForm.descriptionPlaceholder' | translate"></textarea>
    </div>

    <div class="card">
      <div class="ct" style="margin-bottom:10px">{{ 'preventionOffres.offerForm.patientContent.title' | translate }}</div>

      <label class="of-label" for="offerPatientDescription">{{ 'preventionOffres.offerForm.patientContent.descriptionLabel' | translate }}</label>
      <textarea
        id="offerPatientDescription"
        class="textarea-ctrl"
        rows="3"
        [value]="patientDescription()"
        [disabled]="readOnly"
        (input)="onPatientDescriptionChanged($any($event.target).value)"
        [placeholder]="'preventionOffres.offerForm.patientContent.descriptionPlaceholder' | translate"></textarea>

      <label class="of-label" for="offerPatientProcedure" style="margin-top:14px">{{ 'preventionOffres.offerForm.patientContent.procedureLabel' | translate }}</label>
      <textarea
        id="offerPatientProcedure"
        class="textarea-ctrl"
        rows="3"
        [value]="patientProcedure()"
        [disabled]="readOnly"
        (input)="onPatientProcedureChanged($any($event.target).value)"
        [placeholder]="'preventionOffres.offerForm.patientContent.procedurePlaceholder' | translate"></textarea>
      <div class="cs" style="margin-top:4px">{{ 'preventionOffres.offerForm.patientContent.procedureHelp' | translate }}</div>

      <label class="of-label" for="offerAccessMode" style="margin-top:14px">{{ 'preventionOffres.offerForm.patientContent.accessModeLabel' | translate }}</label>
      <select
        id="offerAccessMode"
        class="select-ctrl"
        [value]="accessMode()"
        [disabled]="readOnly"
        (change)="onAccessModeChanged($any($event.target).value)">
        <option value="">{{ 'preventionOffres.offerForm.patientContent.notSetOption' | translate }}</option>
        <option value="WITHOUT_PRESCRIPTION">{{ 'preventionOffres.offerForm.patientContent.accessModes.WITHOUT_PRESCRIPTION' | translate }}</option>
        <option value="PRESCRIPTION_REQUIRED">{{ 'preventionOffres.offerForm.patientContent.accessModes.PRESCRIPTION_REQUIRED' | translate }}</option>
        <option value="PROGRAM_ELIGIBILITY">{{ 'preventionOffres.offerForm.patientContent.accessModes.PROGRAM_ELIGIBILITY' | translate }}</option>
        <!-- OTHER produit le même rendu patient qu'une absence de valeur (prevention.js: accessModeLabel()
             ne le traduit pas) -- jamais un choix actif proposé, masqué de la liste déroulante via
             [hidden] plutôt que retiré du DOM (revue du 2026-09-02) : un retrait structurel (@if) empêche
             le <select> natif d'appliquer [value]="accessMode()" tant que l'<option> correspondante
             n'existe pas encore dans le DOM au moment du binding -- ici l'<option> reste toujours
             présente, seule sa visibilité dans la liste déroulante suit la valeur courante, et elle se
             masque d'elle-même dès que l'utilisateur sélectionne une autre valeur. -->
        <option value="OTHER" [hidden]="accessMode() !== 'OTHER'">{{ 'preventionOffres.offerForm.patientContent.accessModes.OTHER' | translate }}</option>
      </select>

      <label class="of-label" for="offerFundingType" style="margin-top:14px">{{ 'preventionOffres.offerForm.patientContent.fundingTypeLabel' | translate }}</label>
      <select
        id="offerFundingType"
        class="select-ctrl"
        [value]="fundingType()"
        [disabled]="readOnly"
        (change)="onFundingTypeChanged($any($event.target).value)">
        <option value="">{{ 'preventionOffres.offerForm.patientContent.notSetOption' | translate }}</option>
        <option value="PATIENT_PAID">{{ 'preventionOffres.offerForm.patientContent.fundingTypes.PATIENT_PAID' | translate }}</option>
        <option value="REIMBURSED">{{ 'preventionOffres.offerForm.patientContent.fundingTypes.REIMBURSED' | translate }}</option>
        <option value="REIMBURSED_IF_ELIGIBLE">{{ 'preventionOffres.offerForm.patientContent.fundingTypes.REIMBURSED_IF_ELIGIBLE' | translate }}</option>
        <option value="MIXED">{{ 'preventionOffres.offerForm.patientContent.fundingTypes.MIXED' | translate }}</option>
        <!-- UNKNOWN : même rationale et même technique [hidden] que OTHER ci-dessus (accessMode). -->
        <option value="UNKNOWN" [hidden]="fundingType() !== 'UNKNOWN'">{{ 'preventionOffres.offerForm.patientContent.fundingTypes.UNKNOWN' | translate }}</option>
      </select>
    </div>

    <div class="card">
      <div class="ct" style="margin-bottom:6px">{{ 'preventionOffres.offerForm.feasibility.title' | translate }}</div>
      <button type="button" class="toggle-row-item of-feasibility-toggle"
              [attr.aria-pressed]="defaultImmediateFeasibility()"
              [disabled]="readOnly"
              (click)="onToggleDefaultImmediateFeasibility()">
        <div>
          <div class="toggle-label">{{ 'preventionOffres.offerForm.feasibility.toggleLabel' | translate }}</div>
          <div class="toggle-sub">{{ 'preventionOffres.offerForm.feasibility.toggleLabelSub' | translate }}</div>
        </div>
        <div [class]="defaultImmediateFeasibility() ? 'toggle-on' : 'toggle-off'"></div>
      </button>
    </div>

    <div class="card">
      <div class="ct">{{ 'preventionOffres.offerForm.additionalItemsLabel' | translate }}</div>
      <div class="cs" style="margin:4px 0 10px">{{ 'preventionOffres.offerForm.additionalItemsHelp' | translate }}</div>
      <div class="of-chips">
        @for (item of additionalItems(); track item; let i = $index) {
          <span class="of-chip" [class.of-chip-locked]="item === lockedAdditionalItem"
                [title]="item === lockedAdditionalItem ? ('preventionOffres.offerForm.errors.additionalItemLockedHint' | translate) : null">
            {{ item }}
            @if (!readOnly) {
              <button type="button" class="of-chip-remove" (click)="onRemoveAdditionalItem(i)" [attr.aria-label]="'preventionOffres.offerForm.removeItemAriaLabel' | translate">×</button>
            }
          </span>
        }
      </div>
      @if (!readOnly) {
        <div class="of-add-item-row">
          <input
            class="input"
            type="text"
            [value]="newAdditionalItemDraft()"
            (input)="onNewAdditionalItemDraftChanged($any($event.target).value)"
            (keydown.enter)="onAddAdditionalItem()"
            [placeholder]="'preventionOffres.offerForm.additionalItemPlaceholder' | translate">
          <button type="button" class="btn-ps-sm" (click)="onAddAdditionalItem()">{{ 'preventionOffres.offerForm.addButton' | translate }}</button>
        </div>
      }
      @if (duplicateAdditionalItemAttempted()) {
        <div class="of-error">{{ 'preventionOffres.offerForm.duplicateAdditionalItem' | translate }}</div>
      }
    </div>

    <!-- Photo de l'offre (catalogue groupe) : projetée par offer-form-page.component via
         [of-left-extra] pour rester empilée sous "Contenus supplémentaires" dans CETTE colonne,
         plutôt qu'en bloc pleine largeur sous toute la grille -- ce composant reste volontairement
         propriétaire de sa mise en page, jamais de son état/logique (toujours côté page hôte).
         "Sites & tarifs" n'est plus projeté ici depuis l'ajustement UI 2026-09-07 : remonté en tête
         de offer-form-page.component.html, avant <app-offer-form>, comme action de premier plan. -->
    <ng-content select="[of-left-extra]"></ng-content>
  </div>

  <div class="of-col">
    <div class="card">
      <div class="ct" style="margin-bottom:4px">{{ 'preventionOffres.offerForm.bilansLabel' | translate }} *</div>
      @if (activeSiteCount > 0) {
        <div class="of-lock">🔒 {{ 'preventionOffres.offerForm.bilanLockMessage' | translate }}</div>
      }
      <div style="margin-top:10px">
        <app-bilan-picker
          [families]="families"
          [bilans]="bilans"
          [selectedCodes]="orderedBilanCodes()"
          [disabled]="bilanCompositionLocked"
          (toggleBilan)="onToggleBilan($event)">
        </app-bilan-picker>
      </div>
      @if (bilansError() && !bilanCompositionLocked) {
        <div class="of-error" style="margin-top:8px">{{ 'preventionOffres.offerForm.errors.bilansRequired' | translate }}</div>
      }
      <!-- Support multi-catégorie (backend V317) : masqué tant que la composition ne peut couvrir
           qu'un seul domaine (valeur alors toujours émise à false, voir effectiveAllowMultiCategory).
           Jamais soumis au verrou de composition (bilanCompositionLocked) -- seul readOnly le fige. -->
      @if (multiCategoryOptionAvailable()) {
        <div class="of-multi-category">
          <label class="of-multi-category-row" [class.disabled]="readOnly">
            <input
              id="offerAllowMultiCategory"
              type="checkbox"
              [checked]="allowMultiCategory()"
              [disabled]="readOnly"
              (change)="onToggleAllowMultiCategory()">
            <span class="of-multi-category-label">{{ 'preventionOffres.offerForm.multiCategory.label' | translate }}</span>
          </label>
          <div class="cs of-multi-category-help">{{ 'preventionOffres.offerForm.multiCategory.help' | translate }}</div>
          <div class="cs of-multi-category-help">{{ 'preventionOffres.offerForm.multiCategory.note' | translate }}</div>
        </div>
      }
    </div>
  </div>
</div>

@if (serverError) {
  <div class="card of-server-error" style="margin-bottom:16px">{{ serverError }}</div>
}

@if (!readOnly) {
  <div style="display:flex;justify-content:flex-end">
    <button class="btn-submit-primary" [disabled]="!isValid() || saving" (click)="onSubmit()">
      {{ (saving
        ? 'preventionOffres.offerForm.saving'
        : (mode === 'create'
          ? (initialTemplate ? 'preventionOffres.offerForm.createFromTemplateButton' : 'preventionOffres.offerForm.createButton')
          : 'preventionOffres.offerForm.saveButton')) | translate }}
    </button>
  </div>
}
